import React from "react";
import { Route, Redirect } from "react-router-dom";

const ProtectedRoute = ({
  component: Component,
  requiredFormStatus,
  ...rest
}) => {
  const checkAccess = () => {
    const loginData = localStorage.getItem("id");

    if (!loginData) {
      return { hasAccess: false, redirectTo: "/" };
    }

    const userData = JSON.parse(loginData)[0];
    const { form_1_submitted, form_2_submitted } = userData || {};

    switch (requiredFormStatus) {
      case "form_1":
      case "form_2":
        return { hasAccess: true };

      case "form_3":
        if (form_1_submitted === "diisi" && form_2_submitted === "diisi") {
          return { hasAccess: true };
        }
        if (form_1_submitted !== "diisi") {
          return { hasAccess: false, redirectTo: "/form" };
        }
        return { hasAccess: false, redirectTo: "/form-2" };

      default:
        return { hasAccess: true };
    }
  };

  return (
    <Route
      {...rest}
      render={(props) => {
        const accessCheck = checkAccess();

        if (accessCheck.hasAccess) {
          return <Component {...props} />;
        }

        return <Redirect to={accessCheck.redirectTo} />;
      }}
    />
  );
};

export default ProtectedRoute;
